import { Capacitor } from "@capacitor/core";
import {LogLevel} from "@azure/msal-browser"

export const msalConfig = {
  auth: {
    clientId: "1e008368-339b-4732-867d-42940b9ec98f",
    authority: 'https://swimpilot.ciamlogin.com/',
   // redirectUri: process.env.REACT_APP_redirectUri,
   redirectUri: Capacitor.getPlatform() === 'android' ? 'https://localhost' : process.env.REACT_APP_redirectUri,
    keyHash: "dYfpb+P1xNf82jEp8PBz0zqtZAY=" // Android only, the key hash as obtained from the Android app signing
  }, system: {
        loggerOptions: {
            logLevel: LogLevel.Verbose,
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            },
            piiLoggingEnabled: false
        },
        iframeHashTimeout:  Capacitor.getPlatform() === 'android' ? 1000 : 6000, // Timeout für iframe in Millisekunden (Standard: 6000ms)
        loadFrameTimeout: Capacitor.getPlatform() === 'android' ? 1000 : 6000,  // Timeout für das Laden des iframe (Standard: 6000ms)
    },
  cache: {
    cacheLocation: "localStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  }
};

export const loginRequest = {
  scopes: ['profile']
};
export const loginRequest_api = {
  scopes: ['api://fed10d6d-c0ec-4b67-baf0-7ee299f2a361/access_as_user']
};


// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
  graphUsersEndpoint: "https://graph.microsoft.com/v1.0/users",
  graphCalendarEndpoint: "https://graph.microsoft.com/v1.0/me/calendarView"
};
